import { formatInternational } from "@/helpers/phone_number/phone_number.helpers";
import { TFunction } from "i18next";

export function getTooltipContent(
  t: TFunction,
  fullName?: string | null,
  companyName?: string | null,
  number?: string
) {
  if (fullName && companyName) {
    return `${fullName} ${t("call_details.at_company", {
      company: companyName,
    })}`;
  }
  if (fullName) {
    return fullName;
  }
  if (number) {
    return formatInternational(number);
  }
  return "";
}
